import { customerBaseApi } from "@/react/services/api/api";
import { AGENT_GROUPS } from "../constants";
import { agentGroupsPath } from "../urls";
import { KEY } from "@/react/components/table/useTableMutations";
import schema from "./schema";
import { handleMutationResponse } from "@/react/services/api/handleMutationResponse";
import { createNotifier } from "@/react/notifications";

export const agentGroupsApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getAgentGroups: build.query({
      query: (tenantName) => ({
        url: agentGroupsPath(tenantName),
        method: "GET",
      }),
      providesTags: [AGENT_GROUPS],
    }),
    createAgentGroups: build.mutation({
      query: ({ tenantName, agentGroups }) => ({
        url: agentGroupsPath(tenantName),
        method: "POST",
        body: agentGroups,
      }),
      invalidatesTags: [AGENT_GROUPS],
    }),
    updateAgentGroups: build.mutation({
      query: ({ tenantName, agentGroups }) => ({
        url: agentGroupsPath(tenantName),
        method: "PUT",
        body: agentGroups,
      }),
      invalidatesTags: [AGENT_GROUPS],
    }),
    deleteAgentGroups: build.mutation({
      query: ({ tenantName, agentGroupIds }) => ({
        url: agentGroupsPath(tenantName),
        method: "DELETE",
        body: agentGroupIds,
      }),
      invalidatesTags: [AGENT_GROUPS],
    }),
  }),
});

export const {
  useGetAgentGroupsQuery,
  useCreateAgentGroupsMutation,
  useUpdateAgentGroupsMutation,
  useDeleteAgentGroupsMutation,
} = agentGroupsApi;

export const handleCreateResponse = ({
  rowsToCreate,
  setRowsToCreate,
  setData,
}) =>
  handleMutationResponse({
    rows: rowsToCreate,
    setRows: setRowsToCreate,
    setData,
    responseMappingKey: schema.fields.id.spec.key,
    idKey: KEY,
    notifyContent: createNotifier("create", "agent group"),
  });

export const handleUpdateResponse = ({
  rowsToUpdate,
  setRowsToUpdate,
  setData,
}) =>
  handleMutationResponse({
    rows: rowsToUpdate,
    setRows: setRowsToUpdate,
    setData,
    responseMappingKey: schema.fields.id.spec.key,
    idKey: KEY,
    notifyContent: createNotifier("update", "agent group"),
  });

export const handleDeleteResponse = ({
  rowsToDelete,
  setRowsToDelete,
  setData,
}) =>
  handleMutationResponse({
    rows: rowsToDelete,
    setRows: setRowsToDelete,
    setData,
    responseMappingKey: schema.fields.id.spec.key,
    idKey: KEY,
    notifyContent: createNotifier("delete", "agent group"),
    isVoidResponse: true,
  });
